// components
import GridPageAbstract from '../../GridPageAbstract';
import config from '../../../config';

export default class PartnerApiKeysPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'partnerApiKeys';
        this.Server = this.props.context.getState().server.partnerApiKeys;

        this.hiddenColumns = config?.hiddenColumns?.partnerApiKeys || [];

        this.Head = [
            {
                id: 'partnersId',
                label: 'partner',
                object: 'partner',
                alignRight: false,
                cell: 'Select',
                from: 'partners',
                display: 'name'
            },
            { id: 'apiKey', label: 'apiKey', alignRight: false, cell: 'Text' },
            {
                id: 'dateExpiration',
                label: 'dateExpiration',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'dateCreated',
                label: 'dateCreated',
                alignRight: false,
                cell: 'Date',
                disableEditor: true
            },
            {
                id: 'dateModified',
                label: 'dateModified',
                alignRight: false,
                cell: 'Date',
                disableEditor: true
            }
        ].filter((column) => !this.hiddenColumns.includes(column.id));
    }
}
